import { type Context, type Input } from '../click-to-claim.machine.types';

// ─────────────────────────────────────────────────────────────────────────────

export function generateInitialContext(input: Input): Context {
  return {
    offerId: input.offerId,
    reward: undefined,
  };
}
